import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-currency-list',
	templateUrl: './currency-list.component.html',
	styleUrls: ['./currency-list.component.css'],
})
export class CurrencyListComponent extends ListComponent {
	protected apiUrl = 'currency';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Kursy walut' },
		{ id: 'code', name: 'Kod' },
		{ id: 'exchangeRatePln', name: 'Kurs' },
	];

	filters = {
		limit: 9999,
	};

	protected convertData(data: any) {
		return data.results.map((item) => {
			item.exchangeRatePln = item.exchangeRatePln / 100 + ' zł';
			return item;
		});
	}

	protected loadBefore(): void {
		this.bag.get('/codebook/14/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
